import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';

const BASE_URL = 'v1/genai/gcs_doc_ingestion_configs';

export async function listGcsDocIngestionConfigs() {
  const { status, data, error } = await sendApiRequest('get', BASE_URL);
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200 && data?.gcs_doc_ingestion_configs) {
    return {
      gcsDocIngestionConfigs: data.gcs_doc_ingestion_configs,
      error: null,
    };
  }

  return {
    gcsDocIngestionConfigs: [],
    error: data?.error || error || 'Failed to load GCS ingestion configs.',
  };
}

export async function updateGcsDocIngestionConfig(gcsDocIngestionConfigId, autoDocIngestionEnabled) {
  const url = `${BASE_URL}/${gcsDocIngestionConfigId}`;
  const payload = {
    auto_doc_ingestion_enabled: autoDocIngestionEnabled,
  };
  const { status, data, error } = await sendApiRequest('patch', url, payload);
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200) {
    return {
      gcsDocIngestionConfig: data,
      error: null,
    };
  }

  return {
    gcsDocIngestionConfig: null,
    error: data?.error || error || 'Failed to update GCS ingestion config.',
  };
}

export async function syncGcsDocIngestionConfig(gcsDocIngestionConfigId) {
  const url = `${BASE_URL}/${gcsDocIngestionConfigId}/sync`;
  const { status, data, error } = await sendApiRequest('post', url, {});
  logNetRequest(status, data, error);
  handle400Statuses(status);

  if (status === 200) {
    const merged =
      data?.gcs_doc_ingestion_config != null
        ? data.gcs_doc_ingestion_config
        : data != null && typeof data === 'object' && data.id != null
        ? data
        : null;
    return {
      gcsDocIngestionConfig: merged,
      error: null,
    };
  }

  return {
    gcsDocIngestionConfig: null,
    error: data?.error || error || 'Failed to sync GCS ingestion config.',
  };
}
